import React, { FC } from "react";
import HandleAccordian from "../Handle/HandleAccordian";
import WoodAccordian from "../Wood/WoodAccordian";
import ExteriorCladAccordian from "../ExteriorClad/ExteriorCladAccordian";
import UnitSizeAccordian from "../UnitSize/UnitSizeAccordian";
import ConfigurationAccordian from "../BifoldConfiguration/ConfigurationAccordian";
import QuantityAccordian from "../QuantityAccordian";
import SillAccordian from "../Sill/SillAccordian";
import SwingDirectionAccordian from "../SwingConfiguration/SwingDirection/SwingDirectionAccordian";
import GlassAccordian from "../Glass/GlassAccordian";
import ShootBoltAccordian from "../Shootbolt/ShootBoltAccordian";
import LiteAccordian from "../lites/LiteAccordian";
import StilesRailsAccordian from "../StilesRails/StilesRailsAccordian";
import MaterialAccordian from "../Material/MaterialAccordian";
import HeadTrackColorAccordian from "../HeadTrack/HeadTrackColorAccordian";
import FinAccordian from "../Fin/FinAccordian";
import HingeAccordian from "../Hinge/HingeAccordian";
import StickStopsAccordian from "../StickStops/StickStopsAccordian";
import PaintPrimeAccordian from "../PrimePaint/PrimePaintAccordian";
import StainAccordian from "../Stain/StainAccordian";
import StripAccordian from "../Strip/StripAccordian";
import SpacerAccordian from "../Spacer/SpacerAccordian";
import HeightAccordian from "../Height/HeightAccordian";
import HandleHeightAccordian from "../HandleHeight/HandleHeightAccordian";
import JambAccordian from "../Jamb/JambAccordian";
import { Element } from "react-scroll";
import Location from "../Location/Location";
import AddNotes from "../AddNotes/AddNotes";
import SliderConfigAccordian from "../Sliders/Config/SliderConfigAccordian";
import SliderWidthAccordian from "../Sliders/Width/SliderWidthAccordian";
import AutomationAccordian from "../Sliders/Automation/AutomationAccordian";
import SliderScreenAccordian from "../Sliders/SliderScreen/SliderScreenAccordian";
import SliderSillAccordian from "../Sliders/SliderSill/SliderSillAccordian";
import ConfiguratorBtns from "../ConfiguratorButtons/ConfiguratorBtns";
import RequiredMsgLayout from "../RequiredMsgLayout";
import ErrorMsgs from "../ErrorMsgs";
import KerfAccordian from "../Kerf/KerfAccordian";
import BifoldCornerAccordian from "../Corner/BifoldCornerAccordian";
import BifoldCornerConfigAccordian from "../Corner/BifoldCornerConfigAccordian";
import CornerUnitSizeAccordian from "../Corner/CornerUnitSizeAccordian";
import FPConfigurationAccordian from "../FPConfig/FPConfigurationAccordian";
import PivotConfigAccordian from "../PivotConfig/PivotConfigAccordian";
import FPWidthAccordian from "../FPWidth/FPWidthAccordian";
import FPSillAccordian from "../FPSill/FPSillAccordian";
import PivotPointAccordian from "../PivotPoint/PivotPointAccordian";
import PivotHardwareAccordian from "../PivotHardware/PivotHardwareAccordian";
import PivotMagnetAccordian from "../PivotMagnet/PivotMagnetAccordian";
import PivotBackPlateAccordian from "../PivotBackPlate/PivotBackPlateAccordian";
import PivotSillAccordian from "../PivotSill/PivotSillAccordian";
import PivotHandleAccordian from "../PivotHandle/PivotHandleAccordian";
import PivotDropsealAccordian from "../Dropseal/PivotDropsealAccordian";
import BrioOrCentorAccordian from "../ScreenType/BrioOrCentorAccordian";
import SquareHingesAccordian from "../SquareHinges/SquareHinges";
import MagnetCatchAccordian from "../MagnetCatch/MagnetCatchAccordian";
import useWrapperSelector from "./useWrapperSelector";
import AluminumColorAccordian from "../AluminumColor/AluminumColorAccordian";
import StilesRailsProfile from "../StilesRailsProfile/StilesRailsProfile";
import AlumHandle from "../AlumHandles/AlumHandle";
import AlumSillAccordian from "../Sill/SillAlumAccordian";
import BifoldComboPlacementAccordion from "../Combo/BifoldComboPlacementAccordion";
import BifoldComboUnitSizeAccordian from "../Combo/BifoldComboUnitSizeAccordian";
import BifoldComboHeightAccordian from "../Combo/BifoldComboHeightAccordian";
import BifoldComboConfigAccordian from "../Combo/BifoldComboConfigAccordian";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";
import DoorShoeColorAccordian from "../DoorShoeColor/DoorShoeColorAccordian";

interface AccordianWrapperProps {
  resetValues: () => void;
  editQuote: boolean;
  submitPressed: boolean;
  addDoorToSidebar: (withCheck?: boolean, ignoreUnitCheck?: boolean) => void;
  dealer: string;
  email: string;
}

export function addScrollElements(elementTags: string[]) {
  return elementTags.map((name) => <Element key={name} name={name} />);
}

const AccordianWrapper: FC<AccordianWrapperProps> = ({
  resetValues,
  editQuote,
  submitPressed,
  addDoorToSidebar,
  dealer,
  email
}) => {
  const {
    hideHandlesWithEvenConfigs,
    showHandleHeight,
    isExtCladShown,
    sliderConfig,
    setSliderConfig,
    hideHandles,
    isHandleHeightShown,
    paintOptionShown,
    sliderPocketing,
    exactConfig,
    editBtn,
    materialChoice,
    isAluminum,
    isBifold,
    isBifoldCorner,
    isBifoldDoor,
    isBifoldWindow,
    isBifoldCombo,
    isSlider,
    isSwing,
    isPivot,
    isFixedPanel,
  } = useWrapperSelector(submitPressed, editQuote);
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <div style={{ width: "100%" }}>
      {editBtn &&  !readOnly && <RequiredMsgLayout />}

      <Location editQuote={editQuote} submitPressed={submitPressed} />

      {isBifoldCorner && <BifoldCornerAccordian />}
      {isBifoldCombo && <BifoldComboPlacementAccordion />}

      <MaterialAccordian dealer={dealer} email={email}/>

      <WoodAccordian />

      {isSwing && (
        <SwingDirectionAccordian
          editQuote={editQuote}
          submitPressed={submitPressed}
        />
      )}

      {(isBifoldDoor || isBifoldWindow) && <UnitSizeAccordian/>}

      {isBifoldCombo && <BifoldComboUnitSizeAccordian />}

      {isFixedPanel && <FPWidthAccordian />}

      {isBifoldCorner && <CornerUnitSizeAccordian />}

      {isPivot && (
        <PivotConfigAccordian
          editQuote={editQuote}
          submitPressed={submitPressed}
        />
      )}

      {isSlider && <SliderWidthAccordian setSliderConfig={setSliderConfig} />}

      {isBifoldCombo ? (
        <BifoldComboHeightAccordian />
      ) : (
        <HeightAccordian showHandleHeight={showHandleHeight} />
      )}

      {(isBifoldDoor || isBifoldWindow) && (
        <ConfigurationAccordian
          bifoldType={isBifoldWindow ? "window" : "door"}
          hideHandlesWithEvenConfigs={hideHandlesWithEvenConfigs}
        />
      )}

      {isBifoldCorner && (
        <BifoldCornerConfigAccordian
          hideHandlesWithEvenConfigs={hideHandlesWithEvenConfigs}
        />
      )}

      {isBifoldCombo && (
        <BifoldComboConfigAccordian
          hideHandlesWithEvenConfigs={hideHandlesWithEvenConfigs}
        />
      )}

      {isFixedPanel && <FPConfigurationAccordian />}

      {isSlider && (
        <SliderConfigAccordian
          sliderConfig={sliderConfig}
          setSliderConfig={setSliderConfig}
          editQuote={editQuote}
          submitPressed={submitPressed}
        />
      )}

      {isPivot && <PivotHardwareAccordian />}

      <QuantityAccordian/>

      {addScrollElements(["Exterior Clad Color", "Custom Clad Color"])}

      {isExtCladShown && <ExteriorCladAccordian />}

      {addScrollElements([
        "Aluminum Color",
        "Aluminum Color Interior",
        "Aluminum Color Exterior",
      ])}

      {isAluminum && <AluminumColorAccordian/>}

      {addScrollElements(["Stiles and Rails Profile", "Full Bound Profile"])}

      {isAluminum && <StilesRailsProfile />}

      {addScrollElements(["Stiles and Rails"])}

      {materialChoice && !isAluminum && (
        <StilesRailsAccordian evenConfig={isFixedPanel ? true : hideHandles} />
      )}

      {addScrollElements(["Pivot Point"])}

      {isPivot && <PivotPointAccordian />}

      {addScrollElements(["Paint Color", "Custom Paint Color"])}

      {paintOptionShown === "paint" && <PaintPrimeAccordian />}

      {addScrollElements(["Stain Color"])}

      {paintOptionShown && paintOptionShown !== "paint" && <StainAccordian />}

      {addScrollElements(["Head Track Color"])}

      {isBifold && isAluminum ? null : isBifold ||
        isBifoldCombo ||
        (isFixedPanel && exactConfig === "Fixed Bi-fold") ? (
        <HeadTrackColorAccordian />
      ) : null}

      {addScrollElements(["Weather Strip Color"])}

      {isFixedPanel || (isBifold && isAluminum) ? null : <StripAccordian />}

      {addScrollElements(["Door Shoe Color"])}

      {isSwing && <DoorShoeColorAccordian />}

      {addScrollElements([
        "Handle Style",
        "Handle Finish",
        "Handle Key option",
        "Handle Set",
        "Hanlde Pull Style",
        "Handle Pull Finish",
        "Handle Pull Length",
        "Handle Pull Side",
        "Bluetooth Ext. Handle",
        "Smart Lock Type",
        "Back Plate",
        "Back Plate Finish",
      ])}

      {isBifoldWindow || isFixedPanel || hideHandles ? null : isAluminum ? (
        <AlumHandle />
      ) : isPivot ? (
        <>
          <PivotHandleAccordian />
          <PivotBackPlateAccordian />
          <PivotDropsealAccordian />
        </>
      ) : !hideHandles ? (
        <HandleAccordian hideHandles={hideHandles} />
      ) : null}

      {addScrollElements(["Handle Height", "Thumb Turn Height"])}

      {isHandleHeightShown && !isFixedPanel && <HandleHeightAccordian />}

      {addScrollElements(["Shoot Bolt Color"])}

      {(isBifold || isBifoldCombo) && <ShootBoltAccordian />}

      {addScrollElements([
        "Exterior Stop Profile",
        "Interior Stop Profile",
        "Stickings and Stops Profile",
      ])}

      {(isBifoldDoor || isBifoldWindow) && isAluminum ? null : (
        <StickStopsAccordian />
      )}

      {addScrollElements(["Hinge Color"])}

      {isSwing ? (
        <SquareHingesAccordian />
      ) : !isSlider && !isFixedPanel ? (
        <HingeAccordian />
      ) : null}

      {materialChoice && <LiteAccordian />}

      {addScrollElements(["IG Spacer Color"])}

      <SpacerAccordian />

      {isAluminum && (isBifoldDoor || isBifoldWindow) && <AlumSillAccordian />}

      {isSlider ? (
        <SliderScreenAccordian />
      ) : !isFixedPanel && !isPivot ? (
        <BrioOrCentorAccordian />
      ) : null}

      {isAluminum && (isBifoldDoor || isBifoldWindow) ? null : isAluminum &&
        isSwing ? (
        <AlumSillAccordian />
      ) : isAluminum ? null : isFixedPanel &&
        exactConfig === "Fixed Full Bound" ? null : isPivot ? (
        <PivotSillAccordian />
      ) : !isSlider && !isFixedPanel ? (
        <SillAccordian />
      ) : isFixedPanel ? (
        <FPSillAccordian />
      ) : (
        <SliderSillAccordian
          editQuote={editQuote}
          submitPressed={submitPressed}
        />
      )}

      {addScrollElements(["Magnet Finish"])}

      {isPivot && <PivotMagnetAccordian />}

      {(isBifold || isBifoldCombo) && !hideHandles && <MagnetCatchAccordian />}

      {addScrollElements(["Glass Surface Side"])}

      <GlassAccordian />

      {addScrollElements(["Kerf Custom Setback", "Kerf Setback"])}

      {!isAluminum && <KerfAccordian />}

      {addScrollElements(["Custom Jamb Width", "Jamb Width"])}

      {!isSlider && !isAluminum && <JambAccordian />}

      {addScrollElements([
        "Flashing Fin Custom Setback",
        "Flashing Fin Setback",
      ])}

      {!sliderPocketing && <FinAccordian />}

      {isSlider && <AutomationAccordian />}

      <AddNotes editQuote={editQuote} submitPressed={submitPressed} />

      <ErrorMsgs />

      <ConfiguratorBtns
        resetValues={resetValues}
        addDoorToSidebar={addDoorToSidebar}
      />
    </div>
  );
};

export default AccordianWrapper;
